// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"mp-z","imageAndVideoCount":"np-z","imageAndVideoContainer":"op-z","viewAllReviews":"pp-z"};